import { Box, Button, IconButton, Typography } from "@mui/material";
import AppBarContainer from "../../../components/shared/AppBarContainer";
import PageContentContainer from "../../../components/shared/PageContentContainer";
import { useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { getDirectDebitPeriodTitle, toToman } from "../../../utils/Utils";
import { DirectDebitPeriodType } from "../../../types/DirectDebitTypes";
import WeeklyDayPicker from "./WeeklyDayPicker";
import MonthlyDayPicker from "./MonthlyDayPicker";
import BottomFullWidthButtonContainer from "../../../components/shared/BottomFullWidthButtonContainer";
import ArrowForward from "@mui/icons-material/ArrowForward";

function DirectDebitSetPeriodPage() {
  const navigate = useNavigate();
  const { editableSubscription, setEditableSubscription } = useOutletContext();
  const [editablePeriod, setEditablePeriod] = useState(
    editableSubscription.period
  );
  const [editableDay, setEditableDay] = useState(editableSubscription.day);

  const handleSubmit = () => {
    setEditableSubscription((prev) => {
      return { ...prev, day: editableDay, period: editablePeriod };
    });
    navigate(-1);
  };

  return (
    <>
      <AppBarContainer
        rightElement={
          <IconButton onClick={() => navigate(-1)}>
            <ArrowForward sx={{ color: "common.white" }} />
          </IconButton>
        }
        centerElement={
          <Typography variant="h5" color={"common.white"}>
            پس‌انداز خودکار
          </Typography>
        }
      />
      <PageContentContainer
        sx={{
          overflow: "auto",
          display: "block",
          pb: `calc(env(safe-area-inset-bottom) + 112px )`,
        }}
      >
        <Box sx={{ display: "flex" }}>
          <Box
            sx={{
              flex: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography variant="body2" color="primary.main">
              {getDirectDebitPeriodTitle({
                period: editablePeriod,
                day: editableDay,
              })}
            </Typography>
          </Box>
          <Box
            sx={{
              flex: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography component={"div"} variant="h2" color="primary.main">
              {toToman(editableSubscription.amount)}{" "}
              <Box display={"inline"} typography={"subtitle1"}>
                تومان
              </Box>
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: "flex", mt: "32px" }}>
          {[
            { title: "روزانه", value: DirectDebitPeriodType.DAILY },
            { title: "هفتگی", value: DirectDebitPeriodType.WEEKLY },
            { title: "ماهانه", value: DirectDebitPeriodType.MONTHLY },
          ].map((item) => {
            const isActive = editablePeriod === item.value;
            return (
              <Box
                onClick={() => {
                  setEditablePeriod(item.value);
                }}
                key={item.title}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: 36,
                  flex: 1,
                  borderRadius: 36,
                  bgcolor: isActive ? "primary.main" : "common.white",
                }}
              >
                <Typography
                  variant="body2"
                  color={isActive ? "common.white" : "grey.2"}
                >
                  {item.title}
                </Typography>
              </Box>
            );
          })}
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", mt: "24px" }}>
          {editablePeriod === DirectDebitPeriodType.DAILY ? (
            <Typography variant="subtitle1" color="grey.3" align="center">
              پس‌انداز خودکار شما به صورت روزانه انجام خواهد شد
            </Typography>
          ) : editablePeriod === DirectDebitPeriodType.WEEKLY ? (
            <WeeklyDayPicker day={editableDay} setDay={setEditableDay} />
          ) : (
            <MonthlyDayPicker day={editableDay} setDay={setEditableDay} />
          )}
        </Box>
        <BottomFullWidthButtonContainer>
          <Button
            onClick={handleSubmit}
            sx={{
              color: "common.white",
              typography: "h3",
            }}
            variant="contained"
            fullWidth
          >
            ذخیره بازه زمانی
          </Button>
        </BottomFullWidthButtonContainer>
      </PageContentContainer>
    </>
  );
}

export default DirectDebitSetPeriodPage;
